import { isDate } from 'aegion_common_utilities/lib/DateUtil';

const DECIMAL_SHIFT_GPS_DISTANCE = 3;

// @note - size 8
export const getLattitude = (view, index) => view.getFloat64(index);

// @note - size 8
export const getLongitude = (view, index) => view.getFloat64(index + 8);

// @note - size 1
export const getSurveyType = (view, index) => view.getInt8(index + 16);

// @note - size 4
export const getDateCreated = (view, index) => {
	const epoch = view.getInt32(index + 17) * 1000;
	if (isDate(epoch) && epoch > 0) {
		return new Date(epoch).toISOString();
	}
	return undefined;
};

// @note - size 4
export const getId = (view, index) => {
	// TODO: This is not working with the current data
	return view.getInt32(index + 21) / 100;
};


// @note - size 4
export const getGpsDistance = (view, index) => {
	return view.getInt32(index + 25) / (10 ** DECIMAL_SHIFT_GPS_DISTANCE);
};

// @note - size 4
export const getReadingValue1 = (view, index) => view.getInt32(index + 29);

// @warning - this shares bytes with getAliasList - if both were executed when writing to the buffer, the buffer will be corrupted.
// @note - size 4
export const getReadingValue2 = (view, index) => view.getInt32(index + 33);

// @warning - this shares bytes with getAliasList - if both were executed when writing to the buffer, the buffer will be corrupted.
// @note - size 4
export const getReadingValue3 = (view, index) => view.getInt32(index + 37);

// @warning - this shares bytes with getAliasList - if both were executed when writing to the buffer, the buffer will be corrupted.
// @note - size 4
export const getReadingValue4 = (view, index) => view.getInt32(index + 41);

// @warning - this shares bytes with getAliasList - if both were executed when writing to the buffer, the buffer will be corrupted.
// @note - size 4
export const getReadingValue5 = (view, index) => view.getInt32(index + 45);

// @warning - this shares bytes with getReadingValue2, getReadingValue3, getReadingValue4, getReadingValue5, - if conflicting functions were executed when writing to the buffer, the buffer will be corrupted.
// @note - size 14
// @note - used specifically for survey type REPORTED_ANOMALIES
export const getAliasList = (view, index) => {
	const byteArray = new Uint8Array(view.buffer, index + 33, 14);
	const decoder = new TextDecoder('utf-8');
	const decodedStr = decoder.decode(byteArray);
	return decodedStr;
};


export const PARSERS = {
	getLattitude,
	getLongitude,
	getReadingValue1,
	getReadingValue2,
	getSurveyType,
	getDateCreated,
	getId,
	getGpsDistance,
	getReadingValue3,
	getReadingValue4,
	getReadingValue5,
	getAliasList,
};
